import type { TrpcRouter } from '@api/client';
import { environment } from '@environment';

import { InjectionToken, inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  CreateTRPCProxyClient,
  createTRPCProxyClient,
  httpLink,
} from '@trpc/client';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

import { AuthService } from '../shared/ui/services/auth/auth.service';
import { PromotionalDialogService } from '../shared/ui/services/promotional-dialog/promotional-dialog.service';
import { createErrorHandlerLink } from './trpc-error-handlers';

export const createPhoenixTrpcClient = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const promotionalDialogService = inject(PromotionalDialogService);

  return createTRPCProxyClient<TrpcRouter>({
    links: [
      createErrorHandlerLink({ router, promotionalDialogService }),
      httpLink({
        url: environment.phoenixTrpc,
        headers: async () => ({
          Authorization: await authService.getIdToken(),
        }),
      }),
    ],
  });
};

export const PhoenixTrpcClient = new InjectionToken<
  CreateTRPCProxyClient<TrpcRouter>
>('PHOENIX_TRPC_CLIENT');

export type RouterInput = inferRouterInputs<TrpcRouter>;
export type RouterOutput = inferRouterOutputs<TrpcRouter>;
